module.exports = __webpack_public_path__ + "img/wrench_active.5b5ae392.svg";